<template>
  <div class="live-red-packet">
    <vh-dialog :visible.sync="sendDialogVisible" width="440px" :title="$t('host.k_601001')">
      <div class="live-red-packet_header">
        <p class="header_tip">
          {{ $t('host.k_601002') }}
          <span>{{ $t('host.k_601003') }}</span>
          {{ $t('host.k_601004') }}
        </p>
        <i18n path="host.k_601005" tag="p" class="header_online">
          <template>
            <span class="online">{{ onlineAmount }}</span>
          </template>
        </i18n>
      </div>
      <vh-form class="packet-form-wrap" :model="packetForm">
        <vh-form-item :label="$t('host.k_601007')">
          <vh-input
            class="form-input"
            :class="isCheckCode ? 'vh-form-item_error' : ''"
            maxlength="18"
            :placeholder="$t('host.k_601008')"
            show-word-limit
            v-model.trim="packetForm.code"
          ></vh-input>
          <br />
          <p class="envelope-tips">{{ $t('host.k_601009') }}</p>
        </vh-form-item>

        <vh-form-item :label="$t('host.k_601010')">
          <vh-radio v-model="packetForm.packetType" :label="1" @change="changePacketType">
            {{ $t('host.k_601011') }}
          </vh-radio>
          <vh-radio
            v-model="packetForm.packetType"
            :label="2"
            @change="changePacketType"
            class="radio_last"
          >
            {{ $t('host.k_601012') }}
          </vh-radio>
          <vh-input
            type="text"
            class="form-num"
            :class="isCheckSuccess ? 'vh-form-item_error' : ''"
            @blur="checkNum"
            :placeholder="$t('host.k_601013')"
            @input="keyUpNum"
            :disabled="packetForm.packetType == 1"
            show-word-limit
            v-model.trim="packetForm.num"
          ></vh-input>
        </vh-form-item>
      </vh-form>
      <div class="live-red-packet_btnsbox">
        <vh-button
          type="primary"
          round
          :disabled="packetForm.code.length < 6"
          class="start-btn"
          @click="redpacketSend()"
        >
          {{ $t('host.k_601014') }}
        </vh-button>
      </div>
      <div class="live-red-packet_red-tips">
        <p>{{ $t('host.k_601015') }}</p>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useCodeRedPacketServer } from 'middle-domain';
  import regRule from '@/app-shared/utils/reg-rule.js';
  export default {
    name: 'VmpRedPacketLive',
    data() {
      const redPacketServerState = this.redPacketServer.state;
      return {
        redPacketServerState,
        sendDialogVisible: false,
        isCheckCode: false,
        isCheckSuccess: false,
        packetForm: {
          code: '',
          packetType: 1,
          num: ''
        }
      };
    },
    beforeCreate() {
      this.redPacketServer = useCodeRedPacketServer({
        mode: 'live'
      });
    },
    computed: {
      onlineAmount() {
        return this.redPacketServerState.online;
      },
      role() {
        return this.$domainStore?.state?.roomBaseServer?.watchInitData?.join_info?.role_name;
      }
    },
    methods: {
      keyUpNum(e) {
        this.packetForm.num = e.replace(regRule.replaceNoNum, '');
      },
      handleRedPacket(flag) {
        flag ? this.open() : this.close();
      },
      open() {
        this.sendDialogVisible = true;
        this.restForm();
        this.redPacketServer.getRedpacketTotal();
      },
      close() {
        this.sendDialogVisible = false;
      },
      // 发起红包页面表单参数重置
      restForm() {
        this.isCheckCode = false;
        this.isCheckSuccess = false;
        this.packetForm = {
          code: '',
          packetType: 1,
          num: ''
        };
      },
      redpacketSend() {
        // if (this.isCheckCode) {
        //   this.$message.warning('请输入6~18位汉字、数字或字母');
        //   this.isCheckCode = true;
        //   return;
        // }
        if (this.packetForm.packetType == 2 && (this.isCheckSuccess || this.packetForm.num == '')) {
          this.$message.warning(this.$t('host.k_601016'));
          this.isCheckSuccess = true;
          return;
        }
        let params = {
          red_code: this.packetForm.code,
          join_type: this.packetForm.packetType,
          number: this.packetForm.packetType == 2 ? this.packetForm.num : undefined
        };
        this.redPacketServer
          .createCodeRedPacket(params)
          .then(res => {
            if (res.code === 200) {
              this.sendDialogVisible = false;
              this.restForm();
              this.reportRedPacket();
              this.$message.success(this.$t('host.k_601017'));
              //B端发送红包成功数据埋点
              window.VhallDataAgent.track('interact_publish_response', {
                button_type: 'redpacket_click',
                button_biz_id: res.data.red_packet_uuid,
                is_success: 1
              });
            } else {
              this.$message.error(res.msg);
              //B端发送红包失败数据埋点
              window.VhallDataAgent.track('interact_publish_response', {
                button_type: 'redpacket_click',
                button_biz_id: res.data.red_packet_uuid,
                is_success: 0,
                fail_reason: res.code
              });
            }
          })
          .catch(error => {
            this.$message.error(error.msg);
          });
      },
      reportRedPacket() {
        window.vhallReportForProduct && window.vhallReportForProduct.report(110054);
      },
      checkNum() {
        if (this.packetForm.num == '' || this.packetForm.num > this.onlineAmount) {
          this.$message.warning(this.$t('host.k_601016'));
          this.isCheckSuccess = true;
          return;
        } else {
          this.isCheckSuccess = false;
        }
      },
      changePacketType() {
        if (this.packetForm.packetType == 1) {
          this.packetForm.num = '';
          this.isCheckSuccess = false;
        }
      }
    }
  };
</script>
<style lang="less">
  .live-red-packet {
    .vh-form-item {
      margin-right: 0;
      // width: 100%;
      .vh-form-item__label {
        color: #1a1a1a;
      }
      .vh-form-item__content {
        .vh-input {
          // width: 100%;
          &-tip {
            position: absolute;
            left: 100%;
          }
          &.vh-form-item_error {
            .vh-input__inner {
              border-color: #fb3a32;
            }
          }
        }
      }
    }
    // .form-num {}
    .envelope-tips {
      line-height: 22px;
      font-size: 12px;
      padding-top: 5px;
      color: #999;
    }
    &_header {
      width: 100%;
      text-align: center;
      padding: 14px 0;
      background: #f2f2f2;
      border-radius: 4px;
      margin-bottom: 16px;
      .header_tip {
        font-size: 16px;
        color: #000;
        font-weight: 400;
        span {
          font-weight: 600;
        }
      }
      .header_online {
        font-size: 14px;
        color: #999;
        padding-top: 5px;
        .online {
          color: #fb3a32;
        }
      }
    }
    &_btnsbox {
      padding: 12px 0 16px 0;
      text-align: center;
      .start-btn {
        width: 200px;
        // margin-left: 65px;
        line-height: 20px;
      }
      .btn {
        display: inline-block;
        width: 200px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        background: #fb3a32;
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        &.disabled {
          opacity: 0.6;
          cursor: default;
        }
        &.btn-light-red:hover {
          background: #c51f1d;
        }
      }
    }
    &_red-tips {
      // padding-bottom: 24px;
      text-align: left;
      p {
        color: #999;
        font-size: 12px;
        line-height: 17px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }
  }
</style>
